import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Star } from "@phosphor-icons/react";

const truckIcon = (online) =>
  L.divIcon({
    className: "",
    html: `<div style="position:relative;">
      <div style="background:${online ? "#FF5A36" : "#71717a"};width:34px;height:34px;border-radius:50%;border:3px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,.35);display:flex;align-items:center;justify-content:center;">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#fff" viewBox="0 0 256 256"><path d="M247.4,131.6l-32-64A8,8,0,0,0,208,64H176V56a16,16,0,0,0-16-16H24A16,16,0,0,0,8,56V184a16,16,0,0,0,16,16H41a32,32,0,0,0,62,0h50a32,32,0,0,0,62,0h17a16,16,0,0,0,16-16V136A7.9,7.9,0,0,0,247.4,131.6ZM176,80h27.1l24,48H176ZM72,208a16,16,0,1,1,16-16A16,16,0,0,1,72,208Zm112,0a16,16,0,1,1,16-16A16,16,0,0,1,184,208Z"></path></svg>
      </div>
      ${online ? '<span style="position:absolute;top:-2px;right:-2px;width:11px;height:11px;background:#22c55e;border:2px solid #fff;border-radius:50%;"></span>' : ""}
    </div>`,
    iconSize: [34, 34],
    iconAnchor: [17, 17],
  });

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (points.length === 1) map.setView(points[0], 12);
    else if (points.length > 1) map.fitBounds(points, { padding: [50, 50] });
  }, [points, map]);
  return null;
}

export function CarriersMap({ carriers = [], height = 420 }) {
  const points = carriers.filter((c) => c.lat != null).map((c) => [c.lat, c.lng]);
  const center = points[0] || [-33.4489, -70.6693];

  return (
    <div className="rounded-2xl overflow-hidden border border-zinc-200" style={{ height }} data-testid="carriers-map">
      <MapContainer center={center} zoom={5} style={{ height: "100%", width: "100%" }} scrollWheelZoom={true}>
        <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {carriers.filter((c) => c.lat != null).map((c) => (
          <Marker key={c.userId} position={[c.lat, c.lng]} icon={truckIcon(c.online)}>
            <Popup>
              <div style={{ minWidth: 140 }}>
                <strong>{c.name}</strong><br />
                <span style={{ color: "#71717a" }}>{c.city}</span><br />
                ⭐ {c.rating || "—"} · {c.completedServices} servicios<br />
                <span style={{ color: c.online ? "#16a34a" : "#71717a", fontWeight: 600 }}>{c.online ? "En línea" : "Desconectado"}</span>
              </div>
            </Popup>
          </Marker>
        ))}
        <FitBounds points={points} />
      </MapContainer>
    </div>
  );
}
